import { Twitter } from "lucide-react";
import { Link } from "react-router-dom";
import ComfortToggle from "@/components/ComfortToggle";

export default function Footer() {
  return (
    <footer className="border-t border-[#3a3a3a] bg-[#020202]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-12 gap-x-4 gap-y-8 md:gap-8 mb-16">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3 mb-3">
              <img src="/solspur-mark-128.png" alt="SolSpur" className="w-10 h-10" width={40} height={40} />
              <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#cfff04]">
                // SolSpur
              </div>
            </div>
            <p className="text-[#e2e2e2] text-sm max-w-md">
              Launch a real, tradable token on Solana in 60 seconds. AI-generated logos, AI-generated whitepapers,
              one-click SPL mint. From $19.
            </p>
            <div className="flex gap-3 mt-6">
              <a
                href="https://x.com/solspurr"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-twitter"
                aria-label="SolSpur on X"
                className="w-10 h-10 border border-[#3a3a3a] hover:border-[#cfff04] hover:text-[#cfff04] flex items-center justify-center text-[#e2e2e2] transition-colors"
              >
                <Twitter size={16} />
              </a>
            </div>
          </div>
          <div className="col-span-6 md:col-span-2">
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] mb-4">Product</div>
            <ul className="space-y-2 text-sm text-[#e2e2e2]">
              <li><Link to="/create" className="hover:text-white">Launch Coin</Link></li>
              <li><Link to="/explore" className="hover:text-white">Explore</Link></li>
              <li><Link to="/verified" className="hover:text-white">Verified coins</Link></li>
              <li><Link to="/watchlist" className="hover:text-white">My watchlist</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-2">
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] mb-4">Showcase</div>
            <ul className="space-y-2 text-sm text-[#e2e2e2]">
              <li><a href="/#trade" className="hover:text-white">Demo Trading</a></li>
              <li><a href="/#compliance" className="hover:text-white">Legal Checklist</a></li>
              <li><a href="/#market" className="hover:text-white">Live Market</a></li>
              <li><Link to="/leaderboard" className="hover:text-white" data-testid="footer-leaderboard">Leaderboard</Link></li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-2">
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] mb-4">Legal</div>
            <ul className="space-y-2 text-sm text-[#e2e2e2]">
              <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms</Link></li>
              <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy</Link></li>
              <li><a href="/#compliance" className="hover:text-white">Compliance</a></li>
            </ul>
          </div>
          <div className="col-span-12 md:col-span-2">
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] mb-4">Status</div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-[#00ff41] live-dot" />
              <span className="font-mono text-xs text-[#e2e2e2]">All systems live</span>
            </div>
            <div className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] mt-6 mb-2">Display</div>
            <ComfortToggle testId="comfort-toggle-footer" withLabel />
          </div>
        </div>

        <div className="border-t border-[#3a3a3a] pt-8 flex flex-wrap items-end justify-between gap-6">
          <div className="font-display font-black text-[clamp(3rem,18vw,8rem)] tracking-tighter leading-[0.8] text-white break-all">
            SOLSPUR<span className="text-[#cfff04]">.</span>
          </div>
          <div className="font-mono text-[11px] text-[#d0d0d0] uppercase tracking-widest text-right">
            © 2026 SolSpur Labs
            <br />
            <span className="text-[#d0d0d0]">Utility tokens — not investments. Not financial advice.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
